module.exports = __webpack_public_path__ + "img/DeepeningCardScreenshot-1250h.5575a3a7.webp";